var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDati(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1193_18104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6662 5.98047H3.33378C1.49259 5.98047 0 7.47306 0 9.31425V20.0937C0 21.9349 1.49259 23.4275 3.33378 23.4275H20.6662C22.5074 23.4275 24 21.9349 24 20.0937V9.31425C24 7.47306 22.5074 5.98047 20.6662 5.98047Z",
    fill: "#F5F4D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.572266C10.6174 0.572266 9.49656 1.69307 9.49656 3.0757V6.56797C9.49656 7.31409 10.1014 7.91892 10.8475 7.91892H13.1525C13.8986 7.91892 14.5034 7.31409 14.5034 6.56797V3.07565C14.5034 1.69307 13.3826 0.572266 12 0.572266Z",
    fill: "#5B596E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4.11473C12.489 4.11473 12.8855 3.71828 12.8855 3.22924C12.8855 2.7402 12.489 2.34375 12 2.34375C11.511 2.34375 11.1145 2.7402 11.1145 3.22924C11.1145 3.71828 11.511 4.11473 12 4.11473Z",
    fill: "#4F4D5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3723 20.4052C10.3723 17.8727 8.49581 16.7461 8.49581 16.7461H5.14798C5.14798 16.7461 3.27153 17.8727 3.27153 20.4052H10.3723Z",
    fill: "#E48794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4958 11.3457C10.7377 11.8648 10.8729 12.4438 10.8729 13.0542C10.8729 15.2915 9.05915 17.1057 6.82189 17.1057C4.58414 17.1057 2.77038 15.2915 2.77038 13.0542C2.77038 12.4438 2.90559 11.8648 3.14752 11.3457H10.4958Z",
    fill: "#F4DACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7538 13.4207C3.7538 12.6755 3.92818 11.9711 4.23786 11.3457H3.14752C2.90559 11.8648 2.77038 12.4438 2.77038 13.0542C2.77038 14.6867 3.73666 16.093 5.12813 16.7345C4.2791 15.8869 3.7538 14.7152 3.7538 13.4207Z",
    fill: "#F0C8BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4958 11.3469C9.52467 11.8578 8.23582 12.1688 6.82189 12.1688C5.40749 12.1688 4.11863 11.8578 3.14753 11.3469C3.79171 9.96294 5.19453 9.00391 6.82189 9.00391C8.44877 9.00391 9.85159 9.96294 10.4958 11.3469Z",
    fill: "#5B596E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62963 14.1905C4.42957 14.1905 4.26746 14.0283 4.26746 13.8283V13.4071C4.26746 13.2071 4.42957 13.0449 4.62963 13.0449C4.8297 13.0449 4.99181 13.2071 4.99181 13.4071V13.8283C4.99181 14.0283 4.82965 14.1905 4.62963 14.1905Z",
    fill: "#43404F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01371 14.1905C8.81365 14.1905 8.65154 14.0283 8.65154 13.8283V13.4071C8.65154 13.2071 8.81365 13.0449 9.01371 13.0449C9.21378 13.0449 9.37588 13.2071 9.37588 13.4071V13.8283C9.37588 14.0283 9.21373 14.1905 9.01371 14.1905Z",
    fill: "#43404F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82165 14.4408C6.4955 14.4408 6.18529 14.2995 5.97069 14.0533C5.83924 13.9025 5.85498 13.6737 6.00579 13.5423C6.15655 13.4109 6.3853 13.4266 6.51679 13.5774C6.59382 13.6657 6.70493 13.7164 6.82165 13.7164C6.93836 13.7164 7.04953 13.6657 7.1265 13.5774C7.25795 13.4265 7.48669 13.4109 7.6375 13.5423C7.78831 13.6737 7.80401 13.9025 7.67261 14.0533C7.45801 14.2995 7.1478 14.4408 6.82165 14.4408Z",
    fill: "#43404F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9059 10.949H14.328C14.1279 10.949 13.9658 10.7868 13.9658 10.5868C13.9658 10.3868 14.1279 10.2246 14.328 10.2246H20.906C21.106 10.2246 21.2682 10.3868 21.2682 10.5868C21.2682 10.7868 21.106 10.949 20.9059 10.949Z",
    fill: "#43404F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9059 13.1579H14.328C14.1279 13.1579 13.9658 12.9958 13.9658 12.7958C13.9658 12.5958 14.1279 12.4336 14.328 12.4336H20.906C21.106 12.4336 21.2682 12.5958 21.2682 12.7958C21.2682 12.9958 21.106 13.1579 20.9059 13.1579Z",
    fill: "#43404F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9059 15.3669H14.328C14.1279 15.3669 13.9658 15.2048 13.9658 15.0048C13.9658 14.8047 14.1279 14.6426 14.328 14.6426H20.906C21.106 14.6426 21.2682 14.8047 21.2682 15.0048C21.2682 15.2048 21.106 15.3669 20.9059 15.3669Z",
    fill: "#43404F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9059 19.3181H16.2595C16.0595 19.3181 15.8974 19.1559 15.8974 18.9559C15.8974 18.7559 16.0595 18.5938 16.2595 18.5938H20.9059C21.106 18.5938 21.2681 18.7559 21.2681 18.9559C21.2681 19.1559 21.106 19.3181 20.9059 19.3181Z",
    fill: "#43404F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.80459 14.5209C1.80459 11.1327 2.41507 8.08663 4.69299 5.98047H3.33378C1.49259 5.98047 0 7.47306 0 9.31425V20.0937C0 21.9349 1.49259 23.4275 3.33378 23.4275H4.58168C2.07931 21.3167 1.80459 18.1108 1.80459 14.5209Z",
    fill: "#EFE5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87878 9.00492C6.8598 9.00468 6.84092 9.00391 6.82189 9.00391C5.19453 9.00391 3.79171 9.96294 3.14753 11.3469C3.42852 11.4948 3.73685 11.6252 4.06643 11.7369C4.55754 10.464 5.58852 9.45991 6.87878 9.00492Z",
    fill: "#4F4D5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03155 17.5849C5.03155 17.299 5.06835 17.0211 5.13581 16.7539C4.9752 16.8557 3.27153 17.9923 3.27153 20.4054H6.46778C5.58959 19.7271 5.03155 18.7156 5.03155 17.5849Z",
    fill: "#E06F7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1193_18104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDati);
export default __webpack_public_path__ + "static/media/dati.6e8b1fce8187c03deb1824102041a2da.svg";
export { ForwardRef as ReactComponent };